"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spend = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var redux_1 = require("redux");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var NavTabsContainer_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabsContainer"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var constants_1 = require("containers/MyStack/constants");
var FooterMaker_1 = __importDefault(require("containers/TableMaker/FooterMaker"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var HoCs_1 = require("utils/HoCs");
var processExpenditures_1 = require("utils/processExpenditures");
var populated_1 = require("utils/selectors/populated");
var constants_2 = require("./constants");
var hooks_2 = require("./hooks");
var SpendSearchAndFilter_1 = __importDefault(require("./SpendSearchAndFilter"));
var tableConf_1 = require("./tableConf");
var TransactionsModal_1 = __importDefault(require("./TransactionsModal"));
var utils_1 = require("./utils");
var Header = (0, HeaderMaker_1.default)(tableConf_1.spendTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.spendTableConf);
var Footer = (0, FooterMaker_1.default)(tableConf_1.spendTableConf);
var Spend = function () {
    var lastNMonths = (0, utils_1.getLastNMonths)(constants_2.N_MONTHS);
    var _a = __read(react_1.default.useState(null), 2), selectedItem = _a[0], setSelectedItem = _a[1];
    var serviceStatsArrayPop = (0, react_redux_1.useSelector)(populated_1.selectUnfilteredPopulatedServiceStats);
    var serviceStatsArrayPopWithExpenditure = serviceStatsArrayPop === null || serviceStatsArrayPop === void 0 ? void 0 : serviceStatsArrayPop.filter(function (item) { return !item.isSoftDelete; }).map(function (item) { return (__assign(__assign({}, item), { lastNMonthsExpenditures: lastNMonths.map(function (spend) {
            var _a, _b, _c, _d;
            return (Math.round((((_b = (_a = item === null || item === void 0 ? void 0 : item.expenditures) === null || _a === void 0 ? void 0 : _a[spend.year]) === null || _b === void 0 ? void 0 : _b[spend.month])
                && (0, processExpenditures_1.aggregateMonthlyTransactions)((_d = (_c = item === null || item === void 0 ? void 0 : item.expenditures) === null || _c === void 0 ? void 0 : _c[spend.year]) === null || _d === void 0 ? void 0 : _d[spend.month])) || 0));
        }) })); });
    var serviceStatsArrPopSorted = (0, hooks_1.useSortArray)(serviceStatsArrayPopWithExpenditure, {
        serviceName: function (sS) { var _a, _b; return ((_a = sS.service) === null || _a === void 0 ? void 0 : _a.niceName) || ((_b = sS.service) === null || _b === void 0 ? void 0 : _b.name); },
        companyTeams: function (sS) { var _a; return (_a = sS.companyTeams) === null || _a === void 0 ? void 0 : _a.map(function (t) { return t.name; }).join(' + '); },
    });
    var activeServiceStats = serviceStatsArrPopSorted === null || serviceStatsArrPopSorted === void 0 ? void 0 : serviceStatsArrPopSorted.filter(function (service) { return !service.isSoftDelete; });
    // const inactiveServiceStats = serviceStatsArrPopSorted?.filter((service) => service.isSoftDelete);
    var _b = __read((0, hooks_2.useFilterSpend)(activeServiceStats || []), 3), filteredSStats = _b[0], searchProps = _b[1], filterProps = _b[2];
    if (!(0, react_redux_firebase_1.isLoaded)(serviceStatsArrPopSorted) || !(0, react_redux_firebase_1.isLoaded)(filteredSStats)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Spend", description: "Description of ServicesList" }), (0, jsx_runtime_1.jsx)(NavTabsContainer_1.default, __assign({ ml: -2 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ flex: 1 }, { children: [(0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: constants_1.myStackTabs, onClick: function () { return setSelectedItem(null); } }), (0, jsx_runtime_1.jsx)(SpendSearchAndFilter_1.default, __assign({ serviceStats: serviceStatsArrPopSorted }, searchProps, filterProps))] })) })), (0, jsx_runtime_1.jsxs)(Table_1.default, { children: [(0, jsx_runtime_1.jsx)(Header, { width: "fit-content" }), (0, jsx_runtime_1.jsx)(TableBody_1.default, __assign({ width: "fit-content" }, { children: filteredSStats === null || filteredSStats === void 0 ? void 0 : filteredSStats.map(function (sS) { return ((0, jsx_runtime_1.jsx)(Row, { item: sS, onClickRow: function () { return setSelectedItem(sS); } }, sS.id)); }) })), (0, jsx_runtime_1.jsx)(Footer, { items: filteredSStats, width: "fit-content" })] }), selectedItem && (0, jsx_runtime_1.jsx)(TransactionsModal_1.default, { open: true, onClose: function () { return setSelectedItem(null); }, selectedItem: selectedItem })] }));
};
exports.Spend = Spend;
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, react_1.default.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'serviceName', order: 1 }); })(exports.Spend);
